import React, { useCallback, useEffect, useRef, useState } from 'react';
import { PeopleContainer } from './Search.style';
import { useDispatch } from 'react-redux';
import { handleGetSearchUsersList } from 'redux/features/SearchSlice';
import { Skeleton } from '@mui/material';
import { SearchContainer } from 'pages/layout/Header.style';
import { SearchUserList } from 'pages/layout/Header';
import { EndStyle } from 'pages/home/Home.style';
import { Virtuoso } from 'components';
import { useTranslation } from 'react-i18next';

export default function People({ keyword }) {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const allowBlock = useRef(true);

  const [searchList, setSearchList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [hasMore, setHasMore] = useState(false);
  const [scrollData, setScrollData] = useState({ page: 0 });

  const handlefetch = (pageValue) => {
    if (allowBlock.current) {
      allowBlock.current = false;
      setLoading(true);
      const payload = {
        keyword,
        page: pageValue,
        size: 20,
      };
      dispatch(handleGetSearchUsersList(payload))
        .then((res) => {
          if (res?.data?.rows?.data?.length > 0) {
            setHasMore(res?.data?.hasMore);
            setSearchList((prev) => [...prev, ...res?.data?.rows?.data]);
          }
          setLoading(false);
        })
        .catch((err) => {
          console.log('searchResErr', err);
          setLoading(false);
        });
    }
  };

  useEffect(() => {
    if (keyword) {
      handlefetch(scrollData.page);
      setScrollData({
        page: scrollData.page + 1,
      });
    }
  }, [keyword]);

  const fetchMoreData = useCallback(
    (page) => {
      if (scrollData.page !== page) {
        allowBlock.current = true;
        setScrollData({
          page: scrollData.page + 1,
        });
        handlefetch(scrollData.page);
      }
    },
    [scrollData.page]
  );

  return (
    <PeopleContainer>
      <SearchContainer>
        {searchList?.length > 0 && (
          <Virtuoso
            data={searchList}
            minHeight={'75vh'}
            useWindowScroll
            components={{
              Footer: () => {
                return (
                  !hasMore && (
                    <EndStyle>
                      <span>* * *</span>
                    </EndStyle>
                  )
                );
              },
            }}
            endReached={
              hasMore
                ? () => fetchMoreData(scrollData.page + 1)
                : () => {}
            }
            itemContent={(_, item) => (
              <SearchUserList
                data={item}
                loading={loading}
                keyword={keyword}
                headline={
                  <div className="search-headline">
                    {loading ? (
                      <Skeleton width={200} animation="wave" />
                    ) : (
                      <span>{item.headline}</span>
                    )}
                  </div>
                }
              />
            )}
          />
        )}
        {searchList?.length === 0 &&
          loading &&
          [...Array(3)].map((index) => {
            return (
              <div key={index} className="search-user-container">
                <div className="search-user-item">
                  <Skeleton
                    variant="circular"
                    width={45}
                    height={45}
                    animation="wave"
                  />
                  <div className="search-user-details">
                    <div className="search-displayName">
                      <Skeleton width={200} animation="wave" />
                    </div>
                    <div className="search-username">
                      <Skeleton width={200} animation="wave" />
                    </div>
                  </div>
                </div>
                <div className="search-headline">
                  <Skeleton width={200} animation="wave" />
                </div>
              </div>
            );
          })}
        {searchList?.length === 0 && !loading && keyword?.length > 0 && (
          <div className="no-data-found">
            <div>{t('HomePage.NoFound')}</div>
          </div>
        )}
      </SearchContainer>
    </PeopleContainer>
  );
}
